import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Services() {
  const { t } = useTranslation();

  return (
    <section id="services" className="bg-white py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#255485] text-sm font-medium tracking-wider mb-2">
            {t('services.eyebrow')}
          </p>
          <h2 className="text-2xl sm:text-3xl font-serif text-gray-900">
            {t('services.title')}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8">
          {/* 組織開発コンサルティング */}
          <div className="bg-gradient-to-br from-[#255485]/5 to-[#255485]/10 rounded-2xl p-6 sm:p-8 hover:shadow-xl transition-all duration-300 border border-[#255485]/10">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#255485] rounded-xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-team-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 whitespace-pre-line">
              {t('services.consulting.title')}
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-6">
              {t('services.consulting.desc')}
            </p>
            <div className="space-y-2 sm:space-y-3 mb-6">
              <div className="flex items-start gap-2">
                <i className="ri-check-line text-[#255485] mt-1 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-gray-700">{t('services.consulting.feature1')}</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-check-line text-[#255485] mt-1 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-gray-700">{t('services.consulting.feature2')}</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-check-line text-[#255485] mt-1 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-gray-700">{t('services.consulting.feature3')}</span>
              </div>
            </div>
            <Link
              to="/services/consulting"
              className="inline-flex items-center gap-2 text-[#255485] hover:text-[#1d4166] transition-colors duration-200 font-medium text-sm sm:text-base cursor-pointer"
            >
              {t('services.consulting.link')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          {/* キャッシュレス決済導入支援 */}
          <div className="bg-gradient-to-br from-[#255485]/5 to-[#255485]/10 rounded-2xl p-6 sm:p-8 hover:shadow-xl transition-all duration-300 border border-[#255485]/10">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-[#255485] rounded-xl flex items-center justify-center mb-4 sm:mb-6">
              <i className="ri-bank-card-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4 whitespace-pre-line">
              {t('services.cashless.title')}
            </h3>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-6">
              {t('services.cashless.desc')}
            </p>
            <div className="space-y-2 sm:space-y-3 mb-6">
              <div className="flex items-start gap-2">
                <i className="ri-check-line text-[#255485] mt-1 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-gray-700">{t('services.cashless.feature1')}</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-check-line text-[#255485] mt-1 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-gray-700">{t('services.cashless.feature2')}</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-check-line text-[#255485] mt-1 flex-shrink-0"></i>
                <span className="text-sm sm:text-base text-gray-700">{t('services.cashless.feature3')}</span>
              </div>
            </div>
            <Link
              to="/services/cashless"
              className="inline-flex items-center gap-2 text-[#255485] hover:text-[#1d4166] transition-colors duration-200 font-medium text-sm sm:text-base cursor-pointer"
            >
              {t('services.cashless.link')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
